// HC-0123
import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
export const EXPLORED_FEATURES_KEY = 'trial-guide-explored-features';
export const fetchJsonBlob = async lookupKey => {
  const response = await http.get(`trials/v1/json/for-portal/${lookupKey}?portalId=${PortalIdParser.get()}`);
  return response.jsonData;
};
export const putJsonBlob = (lookupKey, jsonData) => {
  return http.put(`trials/v1/json/for-portal`, {
    data: {
      lookupKey,
      jsonData
    }
  });
};
export const resolveJsonBlob = async lookupKey => {
  const response = await fetchJsonBlob(lookupKey).then(jsonResponse => jsonResponse).catch(() => {
    return {}; // Add this line to handle the case where the response is undefined
  });
  return response;
};